module.exports = __webpack_public_path__ + "static/media/numpy.a06f0f96.png";